.labelWrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  user-select: none;
  font-weight: normal;
  height: 32px;
}

.disabled {
  cursor: not-allowed;
}

.label {
  margin-left: .5rem;
  font-size: 14px;
  font-weight: 600;
  color: var(--gray-darker);
}
